import _ from 'lodash';
import Vue from 'vue';
import VueHead from 'vue-head';
import VueLazyload from 'vue-lazyload';
import App from '@src/App.vue';
import router from '@src/router';
import store from '@store/index';
import eve from '@src/commonEvent';

Vue.config.productionTip = false;

Vue.use(_);
Vue.use(VueHead);
Vue.use(VueLazyload);

new Vue({
  render: (h) => h(App),
  router,
  store,
  template: '',
  i18n: eve.Lang,
}).$mount('#app');
